import { MdOutlineEdit } from "react-icons/md";
import { CustomerAddressModel } from "../../models";
import { CgTrash } from "react-icons/cg";

type Props = {
  address: CustomerAddressModel,
  handleEdit: (id: number | string) => void,
  handleDelete: (id: number | string) => void
}

const AddressBox: React.FC<Props> = ({address, handleEdit, handleDelete}) => {
  return (
    <>
      <div className="dashbord_sec1 dashbord_sec2">
        {address.address_name && <span className={`${address.address_name.toLowerCase()}_colm`}>{address.address_name}</span>}
        <div className="delete_main">
          <p>{address.address_street}, {address.city_name}, {address.state_code}, {address.zip_code}{" "}</p>
          <div className="delete_colm">
            <button className="icon-card" onClick={() => handleEdit(address.id)}>
              <MdOutlineEdit size={20} className="icon-slate"/>
            </button>
            <button className="delete_btn delete_color icon-card" onClick={() => handleDelete(address.id)}>
              <CgTrash size={20}  className="icon-slate"/>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddressBox